import React from 'react'
import "./Credit.Module.css"

export const MyCredits = () => {
  return (
    <div>
      <div className='order-a'>
        Your Credits
      </div>
      <div className='credit-b'>
        <p>Available Fraazo Credit : Rs.0</p>
      </div>
      <div className='credit-c'>
        <p>No data found</p>
      </div>
    </div>
  )
}
